require('./bootstrap');
require('owl.carousel');
require('./headerfooter');

// document.addEventListener('DOMContentLoaded', function() {
//     var myVideos = document.querySelectorAll('.video-gif');
//     myVideos.forEach((myVideo) => {
// 	  myVideo.muted = true;
//     	myVideo.play();
// 	});
// });